import {observable,transaction,map,computed,when,reaction,runInAction,action} from 'mobx';
import RefModel from '../model/RefModel';
import SearchModel from '../model/SearchModel';
class QueryStore{

  init(planObj){
    // this.currentPlanId = planObj.id;
    this.refModel = new RefModel(planObj);
    this.searchModel = new SearchModel(this,planObj);
  }
}
export default QueryStore;
